import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { sequenceTileInput } from './input.tile.js';

const sequenceSequenceTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("Sequence"),
  answerType: z.enum(["Horizontal", "Vertical", "Circuit", "NotSet"]).transform(it => it === "NotSet" ? "Horizontal" : it),
  items: z.array(sequenceTileInput.schema)
}).transform(({
  items,
  ...rest
}) => ({
  ...rest,
  content: items.map((it, index) => sequenceTileInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index,
    arr: items
  }))
}));

export { sequenceSequenceTaskSchema };
//# sourceMappingURL=_schema.js.map
